var render = function render(_c,_vm){return _c('div',{staticClass:"grid-view__group",style:([_vm.data.staticStyle, _vm.data.style])},[_c('div',{staticClass:"grid-view__group-cell",attrs:{"set":(_vm.field = _vm.$options.methods.getField(
        _vm.props.allFieldsInTable,
        _vm.props.groupBy
      ))}},[_c('div',{staticClass:"grid-view__group-value"},[_c(_vm.$options.methods.getGroupByComponent(_vm.field, _vm.parent),{tag:"component",attrs:{"field":_vm.field,"value":_vm.props.value}})],1),_vm._v(" "),(_vm.props.count > 0)?_c('div',{staticClass:"grid-view__group-count"},[_vm._v("\n      "+_vm._s(_vm.props.count)+"\n    ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }